import { render } from "./ConfiguracionViews.vue?vue&type=template&id=e042e7a2&scoped=true"
import script from "./ConfiguracionViews.vue?vue&type=script&lang=js"
export * from "./ConfiguracionViews.vue?vue&type=script&lang=js"

import "./ConfiguracionViews.vue?vue&type=style&index=0&id=e042e7a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e042e7a2"]])

export default __exports__